import CustomSelect from 'components/custom-select';
import { useAuth } from 'context/AuthContext';
import { FC, useEffect, useMemo, useState } from 'react';
import { GetVersion } from 'services/utils';
import { getIndexByValue } from 'utils/helpers';

interface TitleTabOptions {
  title: JSX.Element;
  hideFilter?: boolean;
  options: any;
  className?: string;
  onCallBack: (cycle: any) => void;
  hideLabel?: boolean;
}

const TabTitle: FC<TitleTabOptions> = ({ title, options, onCallBack, hideLabel }: TitleTabOptions) => {
  const { realCycle, cycleSelected, setCycleSelected } = useAuth();

  const [activeCycle, setActiveCycle] = useState('');

  const activeCycleObj = useMemo(() => {
    if (!options || !options.length || !activeCycle) return;
    const result =
      options[
        getIndexByValue(
          options.map((e: any) => {
            e.value = e._id;
            e.label = e.title;
            return e;
          }),
          activeCycle,
        )
      ];

    if (result) onCallBack(result);
    return result;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCycle, options]);

  useEffect(() => {
    if (!options?.[0]) return;

    if (!activeCycle && options?.length > 0) {
      setActiveCycle(
        options.find((x: { _id: string | undefined }) => x._id === cycleSelected?._id) ? cycleSelected?._id : options[0].value,
      );
    }
  }, [activeCycle, cycleSelected?._id, options]);

  return (
    <>
      {!hideLabel ? (
        <div className="flex flex-col items-start justify-start mb-8 lg:flex-row lg:justify-between lg:items-center lg:mb-14">
          <div className="flex flex-col lg:flex-row lg:items-center mb-8 lg:mb-0 lg:space-x-4" tabIndex={0}>
            <h3 className="block text-[22px] mb-3 lg:mb-0" >
              {title}
            </h3>
            {!!activeCycleObj && !!activeCycleObj?.label && (
              <>
                <span className="text-white text-[22px] hidden lg:block">|</span>
                <span className="block text-yellow font-normal text-[22px]">
                  <>Ciclo {activeCycleObj?.label}</>
                </span>
              </>
            )}
          </div>

          {options && (
            <div className="w-full lg:w-[264px]">
            <CustomSelect
              placeholder="Clique para selecionar o ciclo"
              options={options?.map((item: any) => {
                return {
                  label: item.title,
                  value: item._id,
                };
              })}
              onChange={(e: any) => {
                setActiveCycle(e.value);

                const selected = realCycle?.find(x => x._id === e.value);

                if (selected) {
                  setCycleSelected({
                    _id: selected._id,
                    title: selected.title,
                    version: GetVersion(selected.date_start),
                  });
                }
              }}
              value={
                options
                  ?.map((item: any) => {
                    return {
                      label: item.title,
                      value: item._id,
                    };
                  })
                  .find((x: any) => x.value === cycleSelected?._id)
                  ? options
                      ?.map((item: any) => {
                        return {
                          label: item.title,
                          value: item._id,
                        };
                      })
                      .find((x: any) => x.value === cycleSelected?._id)
                  : activeCycleObj
              }
            />
          </div>
        )}
        </div>
      ) : (
        <>
          {options && (
            <div className="w-full lg:w-[264px]">
              <CustomSelect
                placeholder="Clique para selecionar o ciclo"
                options={options?.map((item: any) => {
                  return {
                    label: item.title,
                    value: item._id,
                  };
                })}
                onChange={(e: any) => {
                  setActiveCycle(e.value);

                  const selected = realCycle?.find(x => x._id === e.value);

                  if (selected) {
                    setCycleSelected({
                      _id: selected._id,
                      title: selected.title,
                      version: GetVersion(selected.date_start),
                    });
                  }
                }}
                value={
                  options
                    ?.map((item: any) => {
                      return {
                        label: item.title,
                        value: item._id,
                      };
                    })
                    .find((x: any) => x.value === cycleSelected?._id)
                    ? options
                        ?.map((item: any) => {
                          return {
                            label: item.title,
                            value: item._id,
                          };
                        })
                        .find((x: any) => x.value === cycleSelected?._id)
                    : activeCycleObj
                }
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TabTitle;
